import * as React from "react";
import {
  Container,
  Dropdown,
  Form,
  Button,
  Modal,
  ButtonGroup,
  ToggleButtonGroup,
  ToggleButton,
  Spinner,
  Accordion,
  Card,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  FormControl,
  FormGroup,
} from "react-bootstrap";

import chevronRight from "../../Common/Assets/Images/icons/bx-chevron-right.svg";
import BootstrapTable from "react-bootstrap-table-next";
import { resolve, reject } from "q";

import { ToastContainer, toast } from "react-toastify";
import paginationFactory from "react-bootstrap-table2-paginator";

import { User } from "../../Common/Services/User";
import { RolePremissionSlideout } from "./RolePremissionSlideout";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import _ from "lodash";

import createDOMPurify from "dompurify";

import moment from "moment";
import { Roles } from "../../Common/Services/RolePermissionSetting";
import { idText } from "typescript";
const columns = [
  {
    dataField: "roleName",
    text: "Role",
  },
  {
    dataField: "roleName",
    text: "Role",
    hidden: true,    
    //style:{ backgroundColor: '#c8e6c9':'none' },
    formatter: (cell: any, row: any, rowIndex: any) => {
      return (
        
       <div style={{backgroundColor: 'none'}}>
          {row.roleName}
          </div>
      );
    },
  },
];

const pcolumns = [
  {
    dataField: "displayPermissionName",
    text: "Permission Name",
  },
];

const tcolumns = [
  {
    dataField: "displayPermissionName",
    text: "",
  },
];

const ucolumns = [
  {
    dataField: "userName",
    text: "User Name",
    headerFormatter: () => null, // hides content
    headerStyle: () => {
      return { display: "none" }; // removes space
    },
  },
  {
    dataField: "roleName",
    text: "Role",
    hidden: true,    
    //style:{ backgroundColor: '#c8e6c9':'none' },
    
    formatter: (cell: any, row: any, rowIndex: any) => {
      return (
        
       <div style={{backgroundColor: 'none'}}>
          {row.roleName}
          </div>
      );
    },
  },
];


export class RolePermission extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      htmlItem: [],
      htmlErrorItem: [],
      htmlWarningItem: [],
      searcResult: [],
      roleID:0,
      roleName:'',
      permissionData:[],
      users:[],
      formData: {
        RoleName: "",
        RoleId: "",
        OrderNo: "",
        ResetPwd: "false",
        TenantId: 0,
        RoleTag: "",
        PermissionRoles:[]
      },
      showNewRoleTextbox:true,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleResetPwd = this.handleResetPwd.bind(this);
    this.resetPermissionGrid= this.resetPermissionGrid.bind(this);
  }

  componentDidMount() {
  
    let requestlist = { ...this.state.requestlist };
    this.getroledata(requestlist);
    this.getPermissionData();
    this.getAllUsers();

  }

  
  getAllUsers = () => {

    let TypeUserlist: any = [];

    User.getAllUsers()
      .then(async (result: any | null) => {

        if (result !== null) {
          this.setState({ users: result });

        }
        resolve();

      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });

    
  };

  getroledata = (requestlist: any) => {
    Roles.GetRoleData(requestlist)
      .then(async (result: any[] | null) => {
        console.log(result);
        if (result != null) {
          result.forEach(element => {
            element.selected = (element.roleID == this.state.roleID);
          });
          this.setState({ searcResult: result }, () => {});
        }
        resolve();
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
        reject();
      });
  };

  getPermissionData = () => {
    debugger;
    let requestlist = { ...this.state.requestlist };
    let formData = { ...this.state.formData };
   // requestlist.roleId = this.state.roleID==0?1:this.state.roleID;


    if (this.state.roleID == 0) {
      requestlist.roleId = 1;  // Set to "Administration" role ID (assumed ID = 1)
      formData.RoleName = "Administration";  // Set RoleName to "Administration"
    } else {
      requestlist.roleId = this.state.roleID;  // Use the provided roleID
    }
    //formData.RoleName=this.state.roleID==0?"Administration":formData.RoleName;
    Roles.GetPermissionData(requestlist)


 
      .then(async (result: any[] | null) => {
        console.log(result);
        if (result != null) {
          this.setState({ formData,permissionData: result ,isSaveSpinner: false,showNewRoleTextbox:true,}, () => {});
        }
        resolve();
      })
      .catch((err: any) => {
        this.setState({ isSaveSpinner: false});
        toast.error(`Server Error, ${err}`);
        reject();
      });
  };

  handleRoleOnSelect = (row, isSelect) => { 
    debugger;
   
    let roles = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.searcResult))
    );

    let formData = { ...this.state.formData };
   
    roles.forEach(element => {
        if(element.roleID == row.roleID)
        {
          element.selected = isSelect;
          formData.RoleName =row.roleName;
        }
        else         
          element.selected = false;
    });

  
    this.setState({ searcResult: roles,roleID:row.roleID,showNewRoleTextbox:true,formData:formData ,isSaveSpinner: true },()=>{
      this.getPermissionData();
    });

  };

  SavePermissionRole = () => {

    let request: any = {};
   let permissionRoles: any = [];
   let permissionData = this.state.permissionData;
   let storage = JSON.parse(localStorage.getItem("storage")!);
   let tenantID = storage === null ? 0 : (storage.tenantID as any);
   this.setState({ isSaveSpinner: true });
   permissionData.forEach(element => {
    let item: any = {};
    if(element.selected || this.state.formData.RoleName.toLowerCase() == 'administration')
    {
    item.PermissionID = element.permissionId;
    item.RoleID = this.state.roleID;
    item.TenantID =  tenantID;
    permissionRoles.push(item);
  }
  });

  this.state.formData.RoleId = this.state.roleID;
    this.state.formData.PermissionRoles = permissionRoles;
    

    if (this.state.formData.RoleId == 0 && (this.state.formData.RoleName == '' || this.state.formData.RoleName == undefined)) {
      toast.success("Please select Role.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false });
      return;
    }
    request = Object.assign(
      {},
      
      JSON.parse(JSON.stringify(this.state.formData))
    );
    Roles.SavePermissionRole(request)
      .then(async (result: any | null) => { 
        if (result !== null) {
            toast.success("Role permission has been saved successfully.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "OrderSlideout",
            });
          let requestlist = { ...this.state.requestlist };
          this.getroledata(requestlist);
        }
        
        this.setState({ isSaveSpinner: false,isStateChanged:false });
        resolve();
      })
      .catch((error) => {
        this.setState({ isdefaultColDisabled: false, isSaveSpinner: false });
        reject();
      });
  };

  handleDiscard = () => {
    debugger;
    this.resetPermissionGrid();
    this.setState({ isStateChanged: false,showNewRoleTextbox: true });

  };

  showNewRoleTextbox = () => {
    this.resetPermissionGrid();
    let formData = { ...this.state.formData };
    formData.RoleName=""; 
    this.setState({ showNewRoleTextbox: true,Roleid:0,formData});
  };

  resetPermissionGrid = () => 
  {
    debugger;
    let permissionData = this.state.permissionData;


    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        
      },
    }));

    permissionData.forEach(element => {
      element.selected = false;
    });
    this.setState({ permissionData:permissionData });
  };


  closeSlideOut = () => {
    this.setState({ showSlideout: false });
  };

  rowEvents = {
    onClick: (e: any, row: any, rowIndex: any) => {
      this.setState({
        showSlideout: false,
        templateid: row.id,
        roleID:row.roleID,
        roleName:row.roleName
        
      },()=>{
        
      });
    },
  };

  handleChange = (event: any, FieldType: string) => {
    let isStateChanged = true;
    let start = 0;
    let end = 0;
    debugger;

    let formData = { ...this.state.formData };

    if (FieldType === "RoleName") {
      formData.RoleName =
        event.target.value.trim().length > 0 ? event.target.value : "";
       
    } else if (FieldType === "OrderNo") {
      formData.OrderNo =
        event.target.value.trim().length > 0 ? event.target.value : "";
    } else if (FieldType === "ResetPwd") {
      /// this.generateUsername;
      formData.ResetPwd =
        event.target.value.trim().length > 0 ? event.target.value : "";
    } else if (FieldType === "RoleTag") {
      formData.RoleTag =
        event.target.value.trim().length > 0 ? event.target.value : "";
    }

    this.setState({ formData, isStateChanged, isSpinner: false }, () => {
      // if (FieldType === "invoiceno") {
      //   let txtID = "txtInvoice";
      //   let txtInvoice = $("input[id^='" + txtID + "']")[0] as any;
      //   txtInvoice.selectionStart = start;
      //   txtInvoice.selectionEnd = end;
      // }
    });
  };


  rowStyle = (row, rowIndex) => {
    if (row.selected) {
      return {
        backgroundColor: '#c8e6c9',
        fontWeight: 'bold',
        borderLeft: '4px solid #388e3c'
      };
    }
    return {};
  };



handleResetPwd = (event: any) => {
    const ResetPwd = event.target.checked;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        ResetPwd,
      },
    }));
  };


  handleOnSelect = (row, isSelect) => {
    let permissionData = JSON.parse(JSON.stringify(this.state.permissionData));
    let listItem: any[] = [];
  
    if (row.levelInfo === 2) {
      // Select or unselect this level 2 item
      listItem.push(...permissionData.filter(x => x.permissionId === row.permissionId));
  
      if (isSelect) {
        // If selecting, also select parent (level 1)
        const parent = permissionData.find(x => x.permissionId === row.parentId);
        if (parent) listItem.push(parent);
      }
  
    } else if (row.levelInfo === 3) {
      // Always toggle the level 3 item
      listItem.push(...permissionData.filter(x => x.permissionId === row.permissionId));
  
      if (isSelect) {
        // If selecting, also select parent (level 2)
        const parent = permissionData.find(x => x.permissionId === row.parentId);
        if (parent) listItem.push(parent);
  
        // And grandparent (level 1)
        const grandParent = permissionData.find(x => x.permissionId === parent?.parentId);
        if (grandParent) listItem.push(grandParent);
      }
  
      // ❌ If unselecting level 3, do NOT unselect parent (level 2 or 1)
    }
  
    // Apply selected state
    listItem.forEach(element => {
      element.selected = isSelect;
    });
  
    this.setState({ permissionData, isStateChanged: true });
  };
  

  handleOnSelectAll = (isSelect, rows) => {
    
    const ids = rows.map(r => r.permissionId);
    const pids = rows.map(r => r.parentId);

    let permissionData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.permissionData))
    );

    let listItems:any = [];

    if(rows[0].levelInfo == 2)
    {
      listItems = permissionData.filter(
        (x) => ids.includes(x.permissionId) || ids.includes(x.parentId)
      );
    }
    else if(rows[0].levelInfo == 3)
    {
      listItems = permissionData.filter(
        (x) => ids.includes(x.permissionId) || pids.includes(x.permissionId)
      );
    }

    if (listItems.length > 0) {
      listItems.forEach((element: any, index: any) => {
        element.selected = isSelect;
      });
    };

   this.setState({ permissionData: permissionData,isStateChanged:true });
  };

 

  
  render() {
    const { showSlideout, roleName, permissionData, users, searcResult, isStateChanged } = this.state;
  
    // First Level Expansion (Permissions)
    const expandSplitRow = {
      onlyOneExpanding: false,
      parentClassName: "parent-expand-foo",
      renderer: (row: any) => renderItemTableChild(row),
      expanded: permissionData.filter((a) => a.levelInfo === 1).map(r => r.permissionId),
      showExpandColumn: true,
      expandByColumnOnly: true,
      expandColumnRenderer: ({ expanded }) => (
        <span className={expanded ? "chevronExpended" : "chevronCollpsed"}>
          <img src={chevronRight} alt="chevron Right" />
        </span>
      ),
    };
  
    // Second Level Expansion (Child Permissions)
    const expandSplitRow2 = {
      onlyOneExpanding: false,
      parentClassName: "parent-expand-foo",
      renderer: (row: any) => renderItemTableChild2(row),
      showExpandColumn: true,
      expandByColumnOnly: true,
      nonExpandable: permissionData
      .filter(x => x.levelInfo === 2)    
      .filter(row => 
      !permissionData.some(
        child => child.parentId === row.permissionId && child.levelInfo === 3
      )
    )
    .map(row => row.permissionId),
      // expandColumnRenderer: ({ expanded }) => (
        
      //   <span className={expanded ? "chevronExpended" : "chevronCollpsed"}>
      //     <img src={chevronRight} alt="chevron Right" />
      //   </span>
      // ),
      expandColumnRenderer: ({ expanded, rowKey }) => {
    const hasChildren = permissionData.some(
      x => x.parentId === rowKey && x.levelInfo === 3
    );

    if (!hasChildren) {
      return <span></span>;  
    }

    return (
      <span className={expanded ? "chevronExpended" : "chevronCollpsed"}>
        <img src={chevronRight} alt="chevron Right" />
      </span>
    );
  }
    };
  
    // First Child Renderer
    const renderItemTableChild = (mainrow: any) => {
      const splitDetail = permissionData.filter(
        (x) => x.parentId === mainrow.permissionId && x.levelInfo === 2
      );
  
      return (
        <div className="pt-4 ps-5">
          <BootstrapTable
            keyField="permissionId"
            data={splitDetail}
            columns={tcolumns}
            expandRow={expandSplitRow2}
            selectRow={{
              mode: "checkbox",
              clickToSelect: false,
              selected: splitDetail.filter((x) => x.selected).map(r => r.permissionId),
              onSelect: this.handleOnSelect,
              onSelectAll: this.handleOnSelectAll,
            }}
          />
        </div>
      );
    };
  
    // Second Child Renderer
    const renderItemTableChild2 = (mainrow: any) => {
      const splitDetail2 = permissionData.filter(
        (x) => x.parentId === mainrow.permissionId && x.levelInfo === 3
      );
  
      return (
        <div className="pt-4 ps-5">
          <BootstrapTable
            keyField="permissionId"
            data={splitDetail2}
            columns={tcolumns}
            selectRow={{
              mode: "checkbox",
              clickToSelect: false,
              selected: splitDetail2.filter((x) => x.selected).map(r => r.permissionId),
              onSelect: this.handleOnSelect,
              onSelectAll: this.handleOnSelectAll,
            }}
          />
        </div>
      );
    };
  
    // User Expansion
    const expandUser = {
      onlyOneExpanding: false,
      parentClassName: "parent-expand-foo",
      renderer: (row: any) => renderItemTableChildUser(row),
      showExpandColumn: true,
      expandByColumnOnly: true,
      expandColumnRenderer: ({ expanded }) => (
        <span className={expanded ? "chevronExpended" : "chevronCollpsed"}>
          <img src={chevronRight} alt="chevron Right" />
        </span>
      ),
    };
  
    // User Table Renderer
    const renderItemTableChildUser = (mainrow: any) => {
      const userdetails = users.filter((x) => x.role === mainrow.roleID);
  
      return (
        <div className="pt-4 ps-5">
          <BootstrapTable keyField="user_UniqueID" data={userdetails} columns={ucolumns} />
        </div>
      );
    };
  
    return (
      <React.Fragment>
        <Container fluid className="body-sec">
          <div className="page-heading underline d-flex">
            Roles & Permissions
            <div className="action-group d-flex flex-row ml-auto">
              <Button onClick={this.showNewRoleTextbox}>New Role</Button>
            </div>
          </div>
  
          <div className="container my-3">
            
            <div className="row">
              {/* Roles Table */}
              <div className="col-3">
                <BootstrapTable
                  keyField="roleID"
                  data={searcResult}
                  columns={columns}
                  expandRow={expandUser}
                  rowStyle={this.rowStyle}
                  selectRow={{
                    mode: "radio",
                    clickToSelect: true,
                    style: { backgroundColor: "#c8e6c9" },
                    hideSelectColumn: true,
                    onSelect: this.handleRoleOnSelect,
                    selected: searcResult.filter((x) => x.selected).map(r => r.roleID),
                  }}
                />
              </div>
  
              {/* Permissions Table */}
              <div className="col-6" style={roleName.toLowerCase() === "administration" ? { opacity: 0.5, pointerEvents: "none" } : {}}>
           
               
                {this.state.showNewRoleTextbox && (
                  <div className="container">
                    <Form>
                      <FormGroup>
                        <Form.Control placeholder="Enter RoleName or Select"
                         value={this.state.formData.RoleName==undefined ? "" :this.state.formData.RoleName }
                         disabled={this.state.formData.RoleName==undefined ? true : this.state.formData.RoleName.toLowerCase() === "administration"?true :false}
                      onChange={(event: any) => this.handleChange(event, "RoleName")} 
                    
                      />
                      </FormGroup>
                    </Form>
                  </div>
                )}
     <div className="mt-4" style={{ maxHeight: "75vh", overflowY: "auto", paddingRight: "10px" }}>
                <BootstrapTable
                  keyField="permissionId"
                  data={permissionData.filter((a) => a.levelInfo === 1)}
                  columns={pcolumns}
                  expandRow={expandSplitRow}
                />
                </div>
  
                {/* Save & Discard Buttons */}
                <div className="d-flex align-items-center justify-content-end height-20">
                  {isStateChanged && roleName.toLowerCase() !== "administration" && (
                    <div className="TabFooter-Pay" style={{ minWidth: "83.6%", maxWidth: "100%" }}>
                      <div className="fixed-action">
                        <div className="d-flex align-content-center flex-wrap">
                          <div className="mr-auto message" style={{ marginLeft: "40px" }}>
                            <span>You have unsaved changes</span>
                          </div>
                          <Button variant="primary" className="space btn btn-primary btn-discard" onClick={this.handleDiscard}>
                            Discard
                          </Button>
                          <Button id="btnSave" variant="primary" style={{ marginRight: "40px" }} onClick={this.SavePermissionRole}>
                            Save
                          </Button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
  
          {showSlideout && <RolePremissionSlideout closeSlideOut={this.closeSlideOut} templateid={this.state.templateid} />}
        </Container>
  
        {(this.state.isSpinner || this.state.isSaveSpinner) && (
          <div className="loader-spinner d-flex justify-content-center align-items-center">
            <Spinner animation="border" variant="success" />
          </div>
        )}
      </React.Fragment>
    );
  }
  
}